import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import configureStore from './store/configureStore';
import Root from './client/Root';
import {getConfig} from './config/configProvider';
import {GoogleAnalyticsHelper} from './helpers/googleAnalytics.helper';

export const store = configureStore();

// Wait for environment config to load before initializing the app
const initializeApp = () => {
  const config = getConfig();

  // Initialize Sentry with the correct config
  if (config.sentryUrl) {
    Sentry.init({dsn: config.sentryUrl});
  }

  // Initialize Google Analytics
  GoogleAnalyticsHelper.initialise();

  // Render the React app
  ReactDOM.render(<Root store={store} />, document.getElementById('root'));
};

// Wait for config to load, then initialize
if (window.__ENV_CONFIG_LOADING__) {
  window.__ENV_CONFIG_LOADING__.finally(() => {
    initializeApp();
  });
} else {
  // If config loading promise doesn't exist, initialize immediately
  initializeApp();
}
